import React from "react";
import styled from "styled-components";

const OverlayWrapper = styled.g`
  .st1,
  .st2,
  .st3 {
    fill: #fff11c;
    stroke: #4d4d4d;
  }
  .st2,
  .st3 {
    fill: #ffde00;
  }
  .st3 {
    fill: #fff;
    stroke: #000;
  }
  .st7 {
    stroke: #fff;
    stroke-width: 4;
  }
  .st10,
  .st11,
  .st12,
  .st7,
  .st8,
  .st9 {
    fill: none;
  }
  .st8 {
    stroke-width: 5;
    stroke: #fff;
  }
  .st10,
  .st11,
  .st12,
  .st9 {
    stroke: #000;
  }
  .st10,
  .st11,
  .st12 {
    stroke: #fff;
    stroke-width: 3;
  }
  .st11,
  .st12 {
    stroke-width: 2;
  }
  .st12 {
    stroke: #000;
  }
`;

const OverlayIcon = () => (
  <OverlayWrapper>
    <circle className="icon-bg" cx="150" cy="150" r="150" fill="#382e20" />

    <g id="bananas">
      <g id="banana_1_">
        <path
          d="M264.17 206.44C221 233 176 268 123.32 263.45c-9.99-1.07-20-3.66-29.93-8.1-9.24-3.72-18.03-8.33-26.07-13.71C43.2 225.5 25.79 202.44 23 176c14.74 21.45 36.23 39.85 61.32 52.52 8.37 4.2 17.14 7.76 26.23 10.43 8.41 2.34 16.83 3.62 25.26 3.96C179 244 219 223 258.94 208.16c1.93-.6 3.67-1.17 5.23-1.72z"
          className="st1"
        />
        <path
          d="M262.08 207.04C216 208 173 232 126.63 226.94c-8.93-1.02-17.83-3.07-26.67-6.5-8.31-2.71-16.44-5.9-24.34-9.48-15.79-7.16-30.64-15.88-44.15-25.65 13.5 20.47 33.51 37.38 56.99 48.74 7.83 3.76 16.05 6.91 24.58 9.16C163 256 210 229 255.41 210.02c2.38-1 4.61-1.99 6.67-2.98z"
          className="st2"
        />
      </g>
      <g id="banana_3_">
        <path
          d="M251.22 247.55C238 272 212 286 187.15 292.95c-8.67 2.62-17.43 4.62-26.25 5.71-17.64 2.2-35.51.8-53.31-6.47-9.72-3.61-19.06-8.23-27.74-13.66-34.73-21.69-58.99-56.17-55.33-91.63 10.57 23.95 28.69 46.18 51.72 63.45 7.68 5.75 15.9 10.96 24.58 15.49 8.03 4.53 16.28 7.88 24.68 10.22 14.83 3.98 29.5 4.74 44.04 3.64 7.27-.55 14.52-1.57 21.74-2.88C211 273 232 267 247.41 251.47c1.44-1.32 2.71-2.64 3.81-3.92z"
          className="st1"
        />
        <path
          d="M249.74 249.04C228 259 203 262 179 264c-10 .5-20.25.75-30.42-.19-10.17-.94-20.25-3.06-29.91-7.32-8.53-3.05-16.76-6.86-24.7-11.11-23.8-12.83-45.07-29.38-62.73-47.69 9.5 22.74 26.42 43.23 48.08 58.9 7.22 5.22 14.96 9.91 23.13 13.98 7.76 3.91 15.72 6.8 23.84 8.79 13.9 3.55 27.95 4.14 42.01 2.94 7.03-.6 14.06-1.64 21.07-2.98C209 276 229 269 244.69 255.02c1.85-1.94 3.53-3.94 5.05-5.98z"
          className="st2"
        />
      </g>
      <g id="banana_2_">
        <path
          d="M255.41 228.64C245 245 231 257 216.36 266.9c-8.15 4.04-16.66 7.38-25.31 10.12-25.94 8.21-52.82 11.43-79.58 3.87-9.89-3.22-19.42-7.51-28.34-12.63-35.67-20.49-61.45-54.13-59.38-89.69 11.63 23.57 30.73 45.18 54.52 61.65 7.93 5.48 16.38 10.39 25.26 14.6 8.25 4.03 16.64 6.89 25.16 8.73 14.77 2.82 29.51 2.81 44.15 1.16 7.32-.83 14.62-2.07 21.89-3.57C216 257 235 246 251.1 232.03c1.59-1.2 3.03-2.33 4.31-3.39z"
          className="st1"
        />
        <path
          d="M253.7 229.88C232 237 211 248 186.99 248.43c-6.33.67-12.66 1.23-18.99 1.54-6.33.31-12.67.36-19 .03-9-1-19-3-28.01-5.26-8.69-2.64-17.1-6.13-25.23-10.09-24.36-12.02-46.35-27.84-64.82-45.54 10.51 22.41 28.33 42.3 50.67 57.23 7.45 4.96 15.4 9.38 23.75 13.12 7.77 3.59 15.78 6.16 23.95 7.81 14.23 2.91 28.38 2.85 42.45 1.04 7.03-.91 14.05-2.26 21.04-3.89C214 260 233 250 248.09 235.23c2.01-1.81 3.88-3.59 5.61-5.35z"
          className="st2"
        />
      </g>
      <ellipse
        cx="63.32"
        cy="241.13"
        className="st3"
        rx="12.58"
        ry="14.94"
        transform="rotate(-46.422 63.32812314 241.1425455)"
      />
      <ellipse
        cx="66.32"
        cy="236.32"
        rx="6.65"
        ry="9.06"
        transform="rotate(-52.137 66.31349545 236.3061231)"
      />
      <ellipse
        cx="79.66"
        cy="216.45"
        className="st3"
        rx="14.53"
        ry="20.91"
        transform="matrix(.766 -.6429 .6429 .766 -120.5074 101.8632)"
      />
      <ellipse
        cx="84.01"
        cy="208.17"
        rx="6.28"
        ry="9.15"
        transform="rotate(-40.202 83.99885455 208.15674415)"
      />
      <path stroke="#000" d="M86.89 271.8c7.26-25.47 24.3-38.7 51.11-39.69" />
    </g>
    <g id="over">
      <g id="faceparts_3_">
        <g id="face_3_">
          <path
            id="faceback_1_"
            fill="#ddd"
            stroke="#fff"
            d="M189.57 222.91c3.11-10.83 38.68-81.07 24.19-85.72l-32.61-8.43-36.57-3.58c-3.5-1.28-7.18.02-8.24 2.9l-19.55 53.43c-1.05 2.88.93 6.25 4.42 7.53l29.11 20.99 31.01 15.78c3.5 1.27 7.19-.02 8.24-2.9z"
          />
        </g>
        <ellipse
          cx="180.79"
          cy="180.57"
          fill="#4d4d4d"
          stroke="#000"
          rx="8.28"
          ry="15.48"
          transform="matrix(.5251 -.851 .851 .5251 -67.8171 239.6062)"
        />
        <path
          id="arm_1_"
          d="M188.3 131.12s34.02-18.23 41.51-12.01c7.87 6.54-39.59 45.55-44.97 50.54-1.93 1.79-4.35 3.07-5.01 5.66-.7 2.74.62 7.2.86 10.03"
          className="st7"
        />
        <path
          id="arm"
          d="M141.19 202.21c-15.09 1.52-33.31 5.02-46.66 10.87 1.56-.68 2.03-15.92-1.21-26.04-.73-.62-1.6-1.2-2.64-1.7"
          className="st8"
        />
        <path
          d="M159.35 159.95c1.09 1.08 3.5 3.4 3.72 3.84.65 1.32-1.06-.47 4.15-6.85 3.56-4.37 6.1-5.57 7.01-6.1.91-.53-1.72-1.93-4.63-3.61-10.43-6.03-19.18 4.31-10.25 12.72z"
          className="st9"
        />
      </g>
      <g id="blenderbody_7_">
        <g id="base_7_">
          <path
            d="M206.78 229.04c11.27-24.93 20.65-50.56 28.13-76.89.66-1.8-.58-3.91-2.76-4.71-7.54-6.17-30.68 77.73-33.28 78.69-1.62 4.19 6.43 7.18 7.91 2.91z"
            className="st10"
          />
          <path
            d="M196.24 233.31c12.26-28.51 22.91-57.62 31.94-87.31 1.6-4.48-11.52-9.28-13.19-4.82 0 0 4.71 8.37-10.14 46.53-14.89 43.95-28.9 38.82-17.5 46.05 3.01 1.44 8.07 2.19 8.89-.45z"
            className="st10"
          />
        </g>
        <g id="pitcher_7_">
          <path
            d="M118.66 82.71C95.55 62.63 46.91 14.9 45.78 65.5l2.96 5.51s7.29 1.7 9.26 1.91c-19.42-39.87 53.33 9.38 55.09 21.63.33 2.29-1.89 11.66-1.05 12.64 2.02 2.39 7.74 6.48 7.74 6.48-6.38-7.94 3.15-19.23-1.12-30.96z"
            className="st10"
          />
          <path
            d="M115.43 186.76c4.3-9.91 27.39-59.6 20.07-65.06-1.82-.66-3.93.55-4.72 2.71-6.38 20.56-13.67 40.55-21.93 59.94-1.92 5.03 4.78 7.52 6.58 2.41z"
            className="st10"
          />
          <path
            d="M108.84 184.35l23.03-59.54c-25.29-23.67-52.35-42.59-81.84-55.06 2.38.87-32.61 95.93-39.09 106.86-5.39 11.33 10.83-2.02 16.26-.51 18.28 5.09 59.43 8.39 81.64 8.25z"
            className="st10"
          />
          <path
            d="M102.93 173.32c-13.7 1.86-52.39-.92-66.53-5.13"
            className="st10"
          />
          <path d="M36.16 168.84l5.96-16.29" className="st10" />
          <path d="M47.88 171.14l2.94-8.02" className="st10" />
          <path d="M57.7 171.51l2.93-8.01" className="st10" />
          <path d="M67.38 172.23l2.39-6.52" className="st10" />
          <path d="M77.2 172.61l2.93-8.02" className="st10" />
          <path d="M84.65 172.64l1.9-5.22" className="st10" />
          <path d="M94.46 173.01l4.29-11.73" className="st10" />
          <path d="M103.32 172.6l2.93-8.02" className="st10" />
        </g>
        <g id="top_2_">
          <path
            d="M12.92 129.42l10.02-28.55c2.3-5.17.24-6.77-3.36-5.95-10.35-2.18-14.01 23.93-15.35 31.05-.82 2.34-.31 5 2.36 5.95 2.16 3.72 5.09 2.1 6.33-2.5z"
            className="st10"
          />
          <path
            d="M41.32 68.56C32.8 63.93-3.12 165.65 6.4 168.11 2.92 211.65 62.03 51.83 41.32 68.56z"
            className="st10"
          />
        </g>
      </g>
      <path
        d="M135.91 86.95c6.75-5.95 13.49-11.91 20.24-17.86-.45 12.24-.89 24.48-1.34 36.72 4.55-5.82 9.68-11.08 15.32-15.74"
        className="st11"
      />
      <path
        d="M170.77 64.73c3.74-2.29 7.47-4.58 11.21-6.86-.77 6.69-1.55 13.38-2.32 20.07 3.05-2.27 6.09-4.53 9.14-6.8"
        className="st11"
      />
      <path
        d="M194.33 53.96c2.79-1.51 5.58-3.01 8.38-4.52-.82 4.81-1.65 9.61-2.47 14.42 2.29-1.52 4.58-3.04 6.88-4.56"
        className="st11"
      />
      <path d="M150.79 157.07c.89-.8 2.07-1.19 3.2-1.06" className="st9" />
      <path d="M151.56 145.88c.91.53 1.83 1.05 2.74 1.58" className="st9" />
      <path d="M162.36 138.71c.03 1.03.06 2.07.09 3.1" className="st9" />
      <path
        d="M138.66 144.15c6.94-1.03 13.44-5.64 17.2-12.19"
        className="st12"
      />
      <path
        d="M123.53 170.33c4.47 5.85 6.79 13.65 6.35 21.37"
        className="st12"
      />
      <path
        d="M162.08 167.35c2.62-8.63 9.26-15.76 17.18-18.43"
        className="st9"
      />
      <path
        d="M152.09 175.23c1.43.4 4.54 1.33 5 1.29 1.38-.12-.94-.71-3.08 7.48-1.46 5.6-1.02 8.55-.94 9.67.08 1.12-2.43-.52-5.32-2.24-10.33-6.19-7.04-19.74 4.34-16.2z"
        className="st9"
      />
      <path d="M145.21 169.03c-.14 1.24.2 2.53.91 3.48" className="st9" />
      <path d="M136.93 175.8c.9.54 1.81 1.09 2.71 1.63" className="st9" />
      <path d="M137.21 189.49c.82-.54 1.64-1.07 2.46-1.61" className="st9" />
      <path
        d="M159.33 173.69c-5.29 7.06-7.23 16.95-5.01 25.59"
        className="st9"
      />
      <path
        d="M217.21 204.38c7.42 6.65 14.84 13.3 22.25 19.95 2.57 2.3 5.28 4.68 8.62 5.55 9.52 2.47 18.08-8.17 27.9-7.66 1.14 2.55 1.28.1 2.42 2.65"
        className="st8"
      />
      <path
        d="M228.7 173.37c11.49-9.72 22.98-19.45 34.47-29.17 3.15 18.17 6.29 36.34 9.44 54.51 2.32-.51 4.22-.62 6.55-1.13"
        className="st8"
      />
    </g>
  </OverlayWrapper>
);

export default OverlayIcon;
